import { Icon } from '@coop/components';
import { Warning1Icon } from '@coop/icons';

import styles from './ProductDetails.module.scss';

const ProductDetailsNicotineInformation = () => {
    return (
        <div className={styles.NicotineInformation}>
            <div className={styles.NicotineIcon}>
                <Icon icon={Warning1Icon} width={16} height={16} color="red" aria-hidden />
            </div>
            <span>
                Nikotinläkemedel får inte säljas vid misstanke om langning till någon som inte fyllt
                18 år
            </span>
        </div>
    );
};

export default ProductDetailsNicotineInformation;
